/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldseats2Inputs */

const en_ticketsfieldseats2 = /** @type {(inputs: Ticketsfieldseats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seats`)
};

const de_ticketsfieldseats2 = /** @type {(inputs: Ticketsfieldseats2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze`)
};

/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Ticketsfieldseats2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldseats2 = /** @type {((inputs?: Ticketsfieldseats2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldseats2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldseats2(inputs)
	return de_ticketsfieldseats2(inputs)
});
export { ticketsfieldseats2 as "ticketsFieldSeats" }